<template>
  <div>
    <v-breadcrumbs
        divider=">"
        :items="items"
    >
      <template v-slot:item="{ item }">
        <v-btn text color="primary" :disabled="item.disabled" @click="handleBreadcrumbs(item.href)"
               style="padding: 0; height: auto"
        >{{item.text}}</v-btn>
      </template>
    </v-breadcrumbs>
    <div style="background-color: #F5F5F5">
      <div>
        <v-btn class="mx-2 mt-2" color="primary" depressed :disabled="contract.status != 1" @click="save" v-if="_hasButtonPermission('保存变更')">保存</v-btn>
        <v-btn color="primary" class="mr-2 mt-2" depressed :disabled="!contract.recordId || contract.status!=1" @click="audit" v-if="_hasButtonPermission('审核变更')">审核</v-btn>
      </div>
      <v-form  ref="contractForm">
        <v-card class="ma-2" elevation="0">
          <v-card-title>合同基础信息</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <v-text-field label="合同状态" disabled outlined dense value="执行中"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field label="系统合同号" disabled outlined dense :value="contract.contractId"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field label="物理合同号" disabled outlined dense :value="contract.contractCode"></v-text-field>
              </v-col>
              <v-col cols="3">
                <contract-type label="合同类型" v-model="contract.contractType" :rules="[rules.required]"></contract-type>
              </v-col>
              <v-col cols="3">
                <nc-corp-select label="签约公司" disabled :value="contract.unitcode"></nc-corp-select>
              </v-col>
              <v-col cols="3">
                <nc-dept-select label="承担部门" disabled :value="contract.voucherDept" :unitcode="contract.unitcode"></nc-dept-select>
              </v-col>
              <v-col cols="6">
                <merchants-account-select label="客商" v-model="merchants" :rules="[rules.required]" :unitcode="contract.unitcode"></merchants-account-select>
              </v-col>
              <v-col cols="3">
                <date-range label="合同起止日期" v-model="dateRange" :rules="[rules.required]"></date-range>
              </v-col>
              <v-col cols="3">
                <v-text-field label="免租天数" disabled outlined dense :value="contract.rentFreeDays"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field label="免租说明" disabled outlined dense :value="contract.rentFreeExplain"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field label="签约人" disabled outlined dense :value="contract.contractor"></v-text-field>
              </v-col>
              <v-col cols="3" v-if="contract.storeId">
                <v-text-field label="签约门店" disabled outlined dense :value="contract.storeName" ></v-text-field>
              </v-col>

            </v-row>
            <v-row>
              <v-col cols="6">
                <v-textarea
                    outlined
                    disabled
                    label="备注"
                    :value="contract.remark"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-textarea
                    counter
                    outlined
                    label="改动说明"
                    v-model="contract.updateDescription"
                    :rules="[rules.required, rules.remark]"
                ></v-textarea>
              </v-col>
            </v-row>
            <file-upload v-model="contract.attachList" label="附件"></file-upload>
          </v-card-text>
        </v-card>
        <v-card class="ma-2" elevation="0">
          <v-card-title>费用明细</v-card-title>
          <v-card-text>
            <v-form ref="costForm">
              <v-simple-table dense style="width: 2000px" class="mb-2">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left" width="100">编号</th>
                    <th class="text-center" width="100">费用类型</th>
                    <th class="text-center" width="200">开始日期~结束日期</th>
                    <th class="text-center" width="100">含税金额</th>
                    <th class="text-center" width="100">税率</th>
                    <th class="text-center" width="100">面积</th>
                    <th class="text-center" width="100">分期金额</th>
                    <th class="text-center" width="100">计算方式</th>
                    <th class="text-center" width="100">收费规则</th>
                    <th class="text-center" width="100">收费周期</th>
                    <th class="text-center" width="100">支付时点</th>
                    <th class="text-center" width="100">提成比率</th>
                    <th class="text-center" width="100">基数1</th>
                    <th class="text-center" width="100">比率1</th>
                    <th class="text-center" width="100">基数2</th>
                    <th class="text-center" width="100">比率2</th>
                    <th class="text-center" width="100">基数3</th>
                    <th class="text-center" width="100">比率3</th>
                    <th class="text-center" width="100">操作</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(cost,i) in contract.costList" :key="i">
                    <td><div style="width: 30px">{{i+1}}</div></td>
                    <td><v-select dense outlined :items="costTypeList" item-text="costName" item-value="costType" style="width: 150px" :rules="[rules.required]" v-model="cost.costType" :disabled="!!cost.oldCostId"></v-select></td>
                    <td><date-range style="width: 250px" label="" :rules="[rules.required]" v-model="cost.dateRange" :disabled="!!cost.oldCostId"></date-range></td>
                    <td><price-input :rules="[rules.required]" v-model="cost.price" :disabled="!!cost.oldCostId" style="width: 100px"></price-input></td>
                    <td><v-text-field dense outlined suffix="%" style="width: 100px" :rules="[rules.required,rules.int]" v-model="cost.taxRate" :disabled="!!cost.oldCostId"></v-text-field></td>
                    <td><v-text-field dense outlined style="width: 100px" :rules="[rules.number]" v-model="cost.area"></v-text-field></td>
                    <td><price-input :rules="[rules.required]" v-model="cost.periodPrice" :disabled="!!cost.oldCostId" style="width: 100px"></price-input></td>
                    <td><v-select dense outlined :items="methodList" item-value="id" item-text="name" style="width: 150px" :rules="[rules.required]" v-model="cost.method" :disabled="!!cost.oldCostId"></v-select></td>
                    <td><v-select dense outlined :items="ruleList" item-text="name" item-value="id" style="width: 100px" :rules="[rules.required]" v-model="cost.rule" :disabled="!!cost.oldCostId"></v-select></td>
                    <td><v-text-field dense outlined style="width: 100px" :rules="[rules.required,rules.int,rules.month]" v-model="cost.periodMonth" :disabled="!!cost.oldCostId">
                      <template v-slot:prepend>
                        每
                      </template>
                      <template v-slot:append-outer>
                        月
                      </template>
                    </v-text-field></td>
                    <td><v-text-field dense outlined style="width: 100px" :rules="[rules.required,rules.int,rules.day]" v-model="cost.payDay" :disabled="!!cost.oldCostId">
                      <template v-slot:append-outer>
                        号
                      </template>
                    </v-text-field></td>
                    <td><v-text-field dense outlined suffix="%" style="width: 100px" :rules="[rules.number]" v-model="cost.percentageRate" :disabled="!!cost.oldCostId"></v-text-field></td>
                    <td><price-input v-model="cost.base1" :disabled="!!cost.oldCostId" style="width: 100px"></price-input></td>
                    <td><v-text-field dense outlined suffix="%" style="width: 100px" :rules="[rules.number]" v-model="cost.rate1" :disabled="!!cost.oldCostId"></v-text-field></td>
                    <td><price-input v-model="cost.base2" :disabled="!!cost.oldCostId" style="width: 100px"></price-input></td>
                    <td><v-text-field dense outlined suffix="%" style="width: 100px" :rules="[rules.number]" v-model="cost.rate2" :disabled="!!cost.oldCostId"></v-text-field></td>
                    <td><price-input v-model="cost.base3" :disabled="!!cost.oldCostId" style="width: 100px"></price-input></td>
                    <td><v-text-field dense outlined suffix="%" style="width: 100px" :rules="[rules.number]" v-model="cost.rate3" :disabled="!!cost.oldCostId"></v-text-field></td>
                    <td style="min-width: 70px"><v-btn text color="primary" small @click="deleteCost(i)" v-if="!cost.oldCostId">删除</v-btn></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-form>
            <v-btn block depressed outlined color="primary" @click="addCost" class="mb-2">
              添加
            </v-btn>
            <v-btn block depressed outlined color="primary" @click="computePeriod">
              生成分期明细
            </v-btn>
          </v-card-text>
        </v-card>
        <v-card class="ma-2" elevation="0">
          <v-card-title>定金/保证金</v-card-title>
          <v-card-text>
            <v-simple-table dense class="mb-2">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-center" width="100">性质</th>
                  <th class="text-center" width="100">金额</th>
                  <th class="text-center" width="100">生成日期</th>
                  <th class="text-center" width="100">是否抵充租金</th>
                  <th class="text-center" width="100">核销人</th>
                  <th class="text-center" width="100">核销时间</th>
                  <th class="text-left pl-6" width="1000">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(deposit,i) in contract.depositList" :key="i">
                  <td ><v-select dense outlined style="width: 100px" :items="depositTypeList" item-value="id" item-text="name" :rules="[rules.required]" v-model="deposit.depositType" :disabled="!!deposit.oldDepositId"></v-select></td>
                  <td><price-input :rules="[rules.required]" v-model="deposit.price" :disabled="deposit.status == 2" style="width: 100px"></price-input></td>
                  <td><date-picker style="width: 130px" label="" :rules="[rules.required]" v-model="deposit.payDate" :disabled="deposit.status == 2"></date-picker></td>
                  <td><v-select dense outlined style="width: 100px" :items="depositReplaceList" item-value="id" item-text="name" :rules="[rules.required]" v-model="deposit.isReplace" :disabled="deposit.depositType == 2"></v-select></td>
                  <td class="text-center">{{deposit.status == 2?deposit.checkName:'/'}}</td>
                  <td style="min-width: 200px" class="text-center">{{deposit.status == 2?deposit.checkTime:'/'}}</td>
                  <td><v-btn text color="primary" small @click="deleteDeposit(i)" v-if="deposit.status != 2">删除</v-btn></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-btn block depressed outlined color="primary" @click="addDeposit">
              添加
            </v-btn>
          </v-card-text>
        </v-card>
        <v-card class="ma-2" elevation="0">
          <v-card-title>分期明细</v-card-title>
          <v-card-text>
            <v-simple-table dense class="mb-2">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left" width="100">编号</th>
                  <th class="text-left" width="100">费用类型</th>
                  <th class="text-left" width="100">所属费用编号</th>
                  <th class="text-left" width="100">计提金额</th>
                  <th class="text-left" width="200">分期起止日期</th>
                  <th class="text-left" width="100">应付金额</th>
                  <th class="text-left" width="100">抵充金额</th>
                  <th class="text-left" width="100">实际金额</th>

                  <th class="text-left" width="100">应付日期</th>
                  <th class="text-left" width="100">付款状态</th>
                  <th class="text-left" width="100">计提状态</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(period,i) in contract.periodList" :key="i">
                  <td>{{i+1}}</td>
                  <td>{{ costTypeList[period.costType-1].costName }}</td>
                  <td>{{ period.costIndex + 1 }}</td>
                  <td><price-input style="width: 100px" :rules="[rules.required]" v-model="period.price" :disabled="period.payStatus == 3 || period.payStatus == 2 || period.accuralStatus == 2 || period.accuralStatus == 3"></price-input></td>
                  <td>{{ period.startDate }}~{{ period.endDate }}</td>
                  <td><price-input style="width: 100px" :rules="[rules.required]" v-model="period.duePrice" :disabled="period.payStatus == 3 || period.payStatus == 2 || period.accuralStatus == 2 || period.accuralStatus == 3"></price-input></td>
                  <td><price-input style="width: 100px" v-model="period.replacePrice" :disabled="!costTypeList[period.costType-1].canReplace || period.method != 1 || period.payStatus == 3 || period.payStatus == 2 || period.accuralStatus == 2 || period.accuralStatus == 3"></price-input></td>
                  <td>{{ period.actualPrice?period.actualPrice/100:(period.method == 1?(period.price - period.replacePrice)/100:'/')}}</td>
                  <td><date-picker style="width: 130px" label="" v-model="period.payDate" :disabled="period.payStatus == 3 || period.payStatus == 2 || period.accuralStatus == 2 || period.accuralStatus == 3"></date-picker></td>
                  <td>{{payStatusList[period.payStatus?period.payStatus-1:0].name}}</td>
                  <td>{{accuralStatusList[period.accuralStatus?period.accuralStatus-1:0].name}}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
    <v-overlay :value="waiting">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <!--审核弹出框-->
    <v-dialog v-model="auditInfo.dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">审核</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
              >
                <v-radio-group
                    v-model="auditInfo.status"
                    row
                >
                  <v-radio
                      label="通过"
                      :value="2"
                  ></v-radio>
                  <v-radio
                      label="不通过"
                      :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
              >
                <v-textarea
                    counter
                    outlined
                    label="审核意见"
                    v-model="auditInfo.reason"
                    :rules="[rules.remark]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="this.auditInfo.dialog = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="auditSave"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi";
import FileUpload from "@/components/erp/contract/FileUpload";
import ContractType from "@/components/erp/contract/ContractType";
import MerchantsSelect from "@/components/erp/contract/MerchantsSelect";
import StoreSelect from "@/components/erp/contract/StoreSelect";
import OaUserSelect from "@/components/erp/contract/OaUserSelect";
import PriceInput from "@/components/erp/contract/PriceInput";
import NcDeptSelect from "@/components/erp/contract/NcDeptSelect";
import NcCorpSelect from "@/components/erp/contract/NcCorpSelect";
import MerchantsAccountSelect from "@/components/erp/contract/MerchantsAccountSelect";

export default {
  name: "ContractChange",
  components: {
    MerchantsAccountSelect,
    NcCorpSelect,
    NcDeptSelect, FileUpload, PriceInput, OaUserSelect, StoreSelect, MerchantsSelect, ContractType},
  props: {
    changeInfo:{
      type:Object
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      //面包屑
      items: [
        {
          text: '合同管理',
          disabled: false,
          href: 'list',
        },
        {
          text: '合同变更',
          disabled: true,
          href: 'change',
        },
      ],
      rules:{
        required: value => (!!value || value === 0) || '必填.',
        int:value => ((!value && value != 0)||(Number.isInteger(parseFloat(value)) && value >= 0)) || '只能输入正整数',
        remark:value => (!value || value.length <= 200) || '最多只能200个字',
        number:value=> ((!value && value != 0)||(!isNaN(parseFloat(value)) && value > 0)) || '只能输入数字',
        month: value=> ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0 )) || '只能输入1-12的数字',
        day: value=> ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0 && value <= 31)) || '只能输入1-31的数字',
        mobile: value=> ((!value && value != 0)||(/^1[0-9]{10}$/.test(value))) || '请输入正确的手机号',
        rate: value=> ((!value && value !== 0)||(!isNaN(parseFloat(value)) && value >= 0 && value <=100)) || '只能输入0-100的数字',
      },
      contract:{},
      dateRange:[],
      merchantsAccount:{},
      merchants:{},

      costChange:false,
      costTypeList:[],
      methodList:[{id:1,name:'固定金额'},{id:2,name:'无保底纯扣点'},{id:3,name:'扣点取高'}],
      ruleList:[{id:1,name:'预付'},{id:2,name:'后付'},{id:3,name:'当月付'}],
      defaultCost:{
        costType:null,
        dateRange:[],
        price:null,
        taxRate:null,
        area:null,
        periodPrice:null,
        method:null,
        rule:null,
        periodMonth:null,
        payDay:null,
        percentageRate:null,
        base1:null,
        rate1:null,
        base2:null,
        rate2:null,
        base3:null,
        rate3:null,
      },

      depositTypeList:[{id:1,name:'定金'},{id:2,name:'保证金'}],
      depositReplaceList:[{id:1,name:'是'},{id:0,name:'否'}],
      defaultDeposit:{
        depositType:'',
        price: null,
        payDate:null,
        isReplace:0,
        status: 1,
      },

      payStatusList:[{id:1,name:'未付款'},{id:2,name:'OA审批中'},{id:3,name:'已付款'},{id:4,name:'OA审批失败'}],
      accuralStatusList:[{id:1,name:'未计提'},{id:2,name:'已计提'},{id:3,name:'OA审批中'},{id:4,name:'OA审批失败'}],

      forShow:false,
      waiting:false,

      auditInfo:{
        dialog:false,
        status:2,
        reason:''
      }
    }
  },
  watch:{
    'contract.costList':{
      handler(){
        if(this.forShow){
          this.forShow = false;
        }else{
          this.costChange = true;
        }
      },
      deep:true
    }
  },
  created() {
    this.listCostType();
  },
  mounted(){
    Object.assign(this.contract,this.changeInfo);
    this.getChangeInfo();
  },
  methods:{
    handleBreadcrumbs(href){
      console.log(href);
      this.$emit("formCallback", href)
    },
    getChangeInfo(){
      let me = this;
      if(this.contract.recordId){
        ContractApi.getChangeRecord({recordId:this.contract.recordId}).then(data=>{
          me.handleResponse(data);
        })
      }else{
        ContractApi.getContractChangeInfo({contractId:this.contract.contractId}).then(data=>{
          me.handleResponse(data);
        })
      }
    },
    handleResponse(data){
      let me = this;
        data.unitcode = data.voucherDept.substr(0,2);
        me.contract = data;
        if(!me.contract.status){
          me.contract.status = 1;
        }
        me.dateRange = [data.startDate, data.endDate];

        me.contract.attachList.forEach(attach=>{
          attach.notCanDel = !!attach.oldAttachId;
        });
        me.contract.costList.forEach(cost=>{
          cost.dateRange = [cost.startDate, cost.endDate];
        });
        me.oaUser = JSON.parse(me.contract.oaUserName);
        me.merchants = {merchantsId:data.merchantsId, merchantsName:data.merchantsName, merchantsAccount:data.merchantsAccount};
        if(me.contract.merchantsAccount){
          me.merchantsAccount = JSON.parse(me.contract.merchantsAccount);

        }

        this.$refs.contractForm.resetValidation();
        me.forShow = true;
    },
    addCost(){
      let cost = Object.assign({},this.defaultCost);
      if(!!this.contract.costList && this.contract.costList.length > 0){
        cost = Object.assign({},this.contract.costList[this.contract.costList.length - 1]);
        cost.costId = null;
        cost.costIndex = null;
        cost.oldCostId = null;
        cost.recordId = null;
        cost.costName = null;
      }
      this.contract.costList.push(cost);
    },
    deleteCost(index){
      this.contract.costList.splice(index,1);
    },
    listCostType(){
      let me = this;
      ContractApi.listCostType({type:1}).then(data=>{
          me.costTypeList = data;
      })
    },
    addDeposit(){
      let deposit = Object.assign({}, this.defaultDeposit);
      this.contract.depositList.push(deposit);
    },
    deleteDeposit(index){
      this.contract.depositList.splice(index,1);
    },
    computePeriod(){
      let me = this;
      if(this.costChange){
        let formValid = this.$refs.costForm.validate();
        if(formValid){
          if(!this.contract.costList||this.contract.costList.length == 0){
            this.contract.periodList = [];
            this.costChange = false;
          }else{
            let costList = this.contract.costList;
            costList.forEach(cost=>{
              if(!cost.oldCostId){
                cost.startDate = cost.dateRange[0];
                cost.endDate = cost.dateRange[1];
              }
            })
            ContractApi.computePeriod({costList: costList, periodList:this.contract.periodList}).then(data=>{
                me.contract.periodList = data;
                me.costChange = false;
            })
          }
        }

      }
    },
    save(){
      let me = this;
      if(this.costChange){
        this.$dialog.error({
          title:'错误',
          text:'费用明细修改了还没有生成分期明细，请点击“生成分期明细”按钮并查看分期明细是否正确再保存'
        })
        return;
      }
      console.log(this.contract);
      let formValid = this.$refs.contractForm.validate();
      if(formValid){
        if(!this.dateRange || this.dateRange.length == 0){
          this.$dialog.error({
            title:'错误',
            text:'请选择合同起止日期'
          })
          return;
        }
        this.contract.startDate = this.dateRange[0];
        this.contract.endDate = this.dateRange[1];

        if(!this.merchants.merchantsId){
          this.$dialog.error({
            title:'错误',
            text:'请选择客商'
          })
          return;
        }
        if(!this.merchants.merchantsAccount){
          this.$dialog.error({
            title:'错误',
            text:'请选择银行账号'
          })
          return;
        }
        this.contract.merchantsId = this.merchants.merchantsId;
        this.contract.merchantsName = this.merchants.merchantsName;
        this.contract.merchantsAccount = this.merchants.merchantsAccount;

        if(!this.contract.costList || this.contract.costList.length == 0){
          this.$dialog.error({
            title:'错误',
            text:'请填写费用明细'
          })
          return;
        }

        this.waiting = true;
        ContractApi.saveChangeInfo(this.contract).then(data=>{
          me.waiting = false;
            me.contract.recordId = data;
            me.getChangeInfo();
            me.$dialog.info({
              title:'操作成功',
              text: '保存成功',
            })
        }).catch(error=>{
              me.waiting = false;
            })
      }
    },
    audit(){
      this.auditInfo.dialog = true;
    },
    auditSave(){
      let me = this;
      let param = {
        recordId:this.contract.recordId,
        status:this.auditInfo.status,
        reason: this.auditInfo.reason,
      }
      ContractApi.auditChange(param).then(data=>{
          me.auditInfo.dialog = false;
          me.getChangeInfo();
      })
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
  }
}
</script>

<style scoped>

</style>